module.exports = "/_next/static/images/jioCinemaIcon-c29a77bc99646ba9c4fafa77d9a807ad.webp";